import { render } from "./Read.vue?vue&type=template&id=93f25e3a"
import script from "./Read.vue?vue&type=script&lang=js"
export * from "./Read.vue?vue&type=script&lang=js"

import exportComponent from "C:\\servers\\develope\\coinview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__